<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'satisfaction.replyHistoryModal.title' | translate }}</h3>
      <button class="btn-close" (click)="onClose()">&times;</button>
    </div>

    <div class="modal-body" *ngIf="feedback">
      <div class="feedback-info">
        <p><strong>{{ 'satisfaction.common.patientLabel' | translate }}</strong> {{ feedback.contact_email || 'satisfaction.common.notProvided' | translate }}</p>
        <p><strong>{{ 'satisfaction.common.feedbackDateLabel' | translate }}</strong> {{ formatDate(feedback.created_at) }}</p>
        <p><strong>{{ 'satisfaction.common.ratingLabel' | translate }}</strong> {{ '⭐'.repeat(feedback.score || 0) }} ({{ feedback.score }}/5)</p>
      </div>

      <div class="history-section">
        <h4>{{ 'satisfaction.common.patientCommentHeading' | translate }}</h4>
        <div class="comment-box">
          {{ feedback.comment || 'satisfaction.common.noComment' | translate }}
        </div>
      </div>

      <div class="history-section" *ngIf="feedback.replied_at">
        <h4>{{ 'satisfaction.replyHistoryModal.replySentHeading' | translate }}</h4>
        <div class="reply-info">
          <p><strong>{{ 'satisfaction.replyHistoryModal.sentDateLabel' | translate }}</strong> {{ formatDate(feedback.replied_at) }}</p>
          <p *ngIf="feedback.replied_by_name"><strong>{{ 'satisfaction.common.agentLabel' | translate }}</strong> {{ feedback.replied_by_name }}</p>
        </div>
        <div class="reply-content" *ngIf="feedback.reply_content">
          <h5>{{ 'satisfaction.replyHistoryModal.mailContentHeading' | translate }}</h5>
          <div class="mail-content">
            {{ feedback.reply_content }}
          </div>
        </div>
        <div class="no-content" *ngIf="!feedback.reply_content">
          <p><em>{{ 'satisfaction.replyHistoryModal.noMailContent' | translate }}</em></p>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="onClose()">{{ 'common.actions.close' | translate }}</button>
    </div>
  </div>
</div>
